import get from 'lodash/get';

import persistState from './creators/persistState';

export default persistState({
  key: 'xm.workflowsPreferences',
  slicer: state => ({
    workflowsPreferences: {
      customWorkflowInfoDismissed: get(
        state,
        'workflowsPreferences.customWorkflowInfoDismissed',
        false,
      ),
      isWorkflowListFilteredByEditable: get(
        state,
        'workflowsPreferences.isWorkflowListFilteredByEditable',
        true,
      ),
    },
  }),
});
